import { render, staticRenderFns } from "./px-avatar-grid.vue?vue&type=template&id=ecb25170&scoped=true&"
import script from "./px-avatar-grid.vue?vue&type=script&lang=ts&"
export * from "./px-avatar-grid.vue?vue&type=script&lang=ts&"
import style0 from "./px-avatar-grid.vue?vue&type=style&index=0&id=ecb25170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb25170",
  null
  
)

export default component.exports